<template>
    <div>
        <div class="top-bg"><img src="@/assets/images/bg-up-about-me.svg" alt="bg-up"></div>

        <div id="about-me">
            <div class="d-flex align-items-center">
                <div class="about-me-box">
                    <img class="myPhoto" src="@/assets/images/myPhoto.png" alt="myPhoto">
                    <h2>Hi</h2>
                    <p>I am a full-stack developer based in Helsinki, Finland. Apart from having a cheerful personality and a versatile skill set, I believe that every day is an opportunity to learn something new.</p>
                    <p class="learn-more">
                        <router-link to="/about" id="learn-more"> Learn more </router-link>
                    </p>
                </div>
            </div>
        </div>

        <div class="down-bg"><img src="@/assets/images/bg-down-about-me.svg" alt="bg-down">
    </div>
    </div>
</template>



<script>
export default {
    name: 'AboutMe'
}
</script>



<style>
#about-me {
    background-color: #01766F;
    padding: 10px 0 80px;
}
.myPhoto {
    width: 15%;
    margin-bottom: 30px;
}
.about-me-box {
    margin: 0 auto;
}
.about-me-box h2 {
    color: #fff;
    margin-bottom: 1.2rem;
    font-weight: 700;
}
.about-me-box p {
    color: #fff;
    font-size: 1.2rem;
    width: 40%;
    margin: 0 auto;
}
.learn-more {
    padding-top: 1.5rem;
}
#learn-more {
    color: #F3A822 ;
    text-decoration: none;
}

@media only screen and (max-width: 600px) {
#about-me {
    padding: 20px 0 40px;
}
.myPhoto {
    width: 25%;
}
.about-me-box p {
    font-size: 0.9rem;
    width: 65%;
}
}
</style>